export const VALUE_VIEW_MODELS_LOAD = 'VALUE_VIEW_MODELS_LOAD';
export const VALUE_VIEW_MODELS_LOAD_SUCCESS = 'VALUE_VIEW_MODELS_LOAD_SUCCESS';
export const VALUE_VIEW_MODELS_LOAD_ERROR = 'VALUE_VIEW_MODELS_LOAD_ERROR';
export const VALUE_VIEW_MODEL_LOAD_SUCCESS = 'VALUE_VIEW_MODEL_LOAD_SUCCESS';
export const VALUE_VIEW_MODEL_LOAD_ERROR = 'VALUE_VIEW_MODEL_LOAD_ERROR';
